<template>
  <v-chip label variant="outlined" color="grey">
    {{ $t('common.archived') }}
  </v-chip>
</template>
